"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.button(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n    flex-wrap: wrap;\n    border: 1px solid ", ";\n    border-radius: 10px;\n    flex-direction: column;\n    align-items: center;\n    padding: 15px;\n    background-color: transparent;\n    .number-text{\n        color: ", "; \n        font-family: ", ";\n        font-style: normal;\n        font-weight: normal;\n        font-size: 36px;\n        line-height: 42px;\n        font-feature-settings: 'pnum' on, 'lnum' on;\n    }\n    .name-text{\n        color: ", ";\n        font-family: ", ";\n        font-style: normal;\n        font-weight: 500;\n        font-size: 18px;\n        line-height: 21px;\n    }\n    &:hover{ \n        border: 2px solid ", ";\n    }\n    &.active{\n        border: 1px solid ", ";\n    }\n"])), _variables.GlobalColors.s3, _variables.GlobalColors.original_purpura, _variables.FontFamily.Raleway, _variables.GlobalColors.s4, _variables.FontFamily.Raleway, _variables.GlobalColors.magenta_s2, _variables.GlobalColors.magenta_s2);

exports.Container = Container;